import { render, staticRenderFns } from "./non-real-refund.vue?vue&type=template&id=68f98c1a&"
import script from "./non-real-refund.vue?vue&type=script&lang=ts&"
export * from "./non-real-refund.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports